//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {MCancelIconName, MOkIconName} from '../../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../../Toolkit/Components/Controls/Dialog';
import MButton from '../../Toolkit/Components/Controls/Button';
import MDropDown from '../../Toolkit/Components/Controls/DropDown';
import {MDropDownItem} from '../../Toolkit/Components/Controls/DropDownOption';
import {MNullable} from '../../Toolkit/Utils';
import MFormControl from '../../Toolkit/Components/Controls/FormControl';
import {FluidityTaskTexts} from '../SafeDigConstants';
import MCalendar from '../../Toolkit/Components/Controls/Calendar';
import MTextBox from '../../Toolkit/Components/Controls/TextBox';
import {Checkbox} from 'primereact/checkbox';

//endregion

/** */
type Props = {}

/** */
type State = {
    position?: DialogPositionType;
    visible: boolean;
    data: TaskData;
    isNewEntry: boolean;
    onUploadFile?: (data: TaskData) => void;
}

export type TaskData = {
    taskId: number | undefined;
    taskSubType: number | undefined;
    dueDate: MNullable<Date> | undefined;
    comment: string | undefined;
    supervisionDate: MNullable<Date> | undefined;
    taskComplete: boolean | undefined;
}

/** */
class TaskEditDialog extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.ok_Click = this.ok_Click.bind(this);
        this.na_Click = this.na_Click.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);

        this.UpdateDisabled = this.UpdateDisabled.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            visible: false,
            data: {taskId: 1, taskSubType: undefined, dueDate: undefined, comment: undefined, supervisionDate: undefined, taskComplete: false},
            isNewEntry: false
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(inputCallback: (data: TaskData) => void,
                currentData: TaskData,
                position?: DialogPositionType) {

        let newEntry = false;
        if(currentData.taskId === -1) {
            newEntry = true;
        }

        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.data = currentData;
            draft.isNewEntry = newEntry;
            draft.visible = true;
            draft.onUploadFile = inputCallback;
        });

    }

    public hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private ok_Click() {
        this.state.onUploadFile!(this.state.data!);
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private na_Click() {
        const cancelData = {
            taskId: this.state.data.taskId,
            taskSubType: this.state.data.taskSubType,
            dueDate: this.state.data.dueDate,
            comment: this.state.data.comment,
            supervisionDate: new Date(),
            taskComplete: true
        };

        this.state.onUploadFile!(cancelData);
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private listTaskSubTypes(): MDropDownItem<number>[] {
        const listItems: MDropDownItem<number>[] = [];

        FluidityTaskTexts.forEach((item, index) => {
            if(index !== 0) {
                listItems.push({label: item, value: index});
            }
        });

        return listItems;
    }

    private UpdateDisabled(): boolean {
        return this.state.data.taskSubType === 0 ||
            this.state.data.dueDate === null ||
            this.state.data.comment === null ||
            (this.state.data.taskSubType === 1 && this.state.data.supervisionDate === null);
    }

    private getDialogTemplate(): ReactNode {
        return (
            <div className="formgrid grid">
                <div className="col-12 md:col-12">
                    <MFormControl label={'Select Task'} id={'selecttask'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MDropDown<number> id="tasktype"
                                                   disabled={!this.state.isNewEntry}
                                                   initialValue={this.state.data.taskSubType}
                                                   items={this.listTaskSubTypes()}
                                                   onChange={e => this.safeSetState((draft: State) => draft.data.taskSubType = e!)}/>
                            );
                        }}
                    </MFormControl>
                </div>
                <div className="col-12 md:col-12">
                    <MFormControl label={'Due Date'} id={'duedate'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MCalendar id="TaskDueDate"
                                           initialValue={this.state.data.dueDate!}
                                           disabled={false}
                                           className={fieldClasses}
                                           onChange={e => this.safeSetState((draft: State) => draft.data.dueDate = e!)}/>
                            );
                        }}
                    </MFormControl>
                </div>
                <div className="col-12 md:col-12">
                    <MFormControl label="Comments" id={'comments'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MTextBox id="taskcomments"
                                          maxLength={100}
                                          disabled={false}
                                          initialValue={this.state.data.comment}
                                          className={fieldClasses}
                                          onChange={e => this.safeSetState((draft: State) => draft.data.comment = e!.toString())}/>
                            );
                        }}
                    </MFormControl>
                </div>
                {this.state.data.taskSubType === 1 && <div className="col-12 md:col-12">
                    <MFormControl label={'Supervision Date'} id={'supervisiondate'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MCalendar id="taskSupervisionDate"
                                           initialValue={this.state.data.supervisionDate!}
                                           disabled={false}
                                           className={fieldClasses}
                                           onChange={e => this.safeSetState((draft: State) => draft.data.supervisionDate = e!)}/>
                            );
                        }}
                    </MFormControl>
                </div>}
                <div className="col-12 md:col-12">
                    <Checkbox id="taskcompleted"
                              onChange={e => this.safeSetState((draft: State) => draft.data.taskComplete = e.checked)}
                              checked={this.state.data.taskComplete}/>
                    <label htmlFor={'taskcompleted'} className="ml-2">Complete</label>
                </div>
            </div>);
    }

    private getFooterTemplate(): ReactNode {
        return (
            <div>
                {this.state.data.taskSubType === 1 &&
                    <MButton label="NA"
                             color="warning"
                             icon={'pi pi-thumbs-down'}
                             disabled={false}
                             onClick={this.na_Click}/>}
                <MButton label="OK"
                         color="success"
                         icon={MOkIconName}
                         disabled={this.UpdateDisabled}
                         onClick={this.ok_Click}/>
                <MButton label="Cancel"
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.hide}/>
            </div>
        );
    }

    /** */
    public render(): ReactElement {

        return (
            <Dialog title={'Job Task'}
                    content={this.getDialogTemplate()}
                    footer={this.getFooterTemplate()}
                    position={this.state.position}
                    canClose={true}
                    closeOnEscape={false}
                    visible={this.state.visible}
                    onHide={this.dialog_onHide}/>
        );

    }

}

export default TaskEditDialog;
